import { type SvgProps, SvgWrapper } from '../utils';
export function UnfoldMoreIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M16.4697 14.4697C16.7626 14.1768 17.2374 14.1768 17.5303 14.4697C17.8232 14.7626 17.8232 15.2373 17.5303 15.5302L12.5303 20.5302C12.2374 20.8231 11.7626 20.8231 11.4697 20.5302L6.46972 15.5302C6.17683 15.2373 6.17683 14.7626 6.46972 14.4697C6.76262 14.1768 7.23738 14.1768 7.53027 14.4697L12 18.9394L16.4697 14.4697Z" />
      <path d="M11.5264 3.41796C11.8209 3.17765 12.2557 3.19512 12.5303 3.46972L17.5303 8.46972C17.8232 8.76261 17.8232 9.23737 17.5303 9.53027C17.2374 9.82316 16.7626 9.82316 16.4697 9.53027L12 5.06054L7.53027 9.53027C7.23738 9.82316 6.76262 9.82316 6.46972 9.53027C6.17683 9.23737 6.17683 8.76261 6.46972 8.46972L11.4697 3.46972L11.5264 3.41796Z" />
    </SvgWrapper>
  );
}
